<div class='left-menu'>
  <ul class='nav navbar-nav'>
    @if (!defaults.isReadonlyUser) {
      <li class="separator" [ngClass]="saveService.classSaveButton"></li>
    }
    @if (!defaults.isReadonlyUser) {
      <li [routerLinkActive]="['link-active']" [ngClass]="saveService.classSaveButton">
        <a class='menu-callback' (click)="onSave()" title="Save all Business Keys">
          <span class='glyphicon glyphicon-floppy-disk'></span> Save All
        </a>
      </li>
    }
  </ul>
</div>